export class IdleTimer {
  private timeoutId: ReturnType<typeof setTimeout> | null = null;

  constructor(
    private readonly timeoutMs: number,
    private readonly onTimeout: () => void,
  ) {}

  public reset(): void {
    this.stop();
    this.timeoutId = setTimeout(() => {
      this.onTimeout();
      this.reset();
    }, this.timeoutMs);
  }

  public stop(): void {
    if (!this.timeoutId) return;
    clearTimeout(this.timeoutId);
    this.timeoutId = null;
  }
}
